import React, { useEffect } from 'react';
import ZombiePurgeContent from '../ContentContainer';
import styles from './ZombiePurgeSucess.module.scss';
import { Image, Link, Icon, ActionButton, Ribbon } from 'src/ui/components';
import { RARIBLE_LINKS } from 'src/base/constants';
import gsap from 'gsap';

export default function ZombiePurgeSuccess({ resetPage, purgedZombiesCount, onClickReplay }) {
	// if no query purged count then get API one if not then set to 0
	// this way we ensure we priotise state over API call
	
	const shareOnTwitter = () => {

		const zombiePurgeLink = 'https://www.rareapepes.com/zombie-purge ';

		const text = 'I\'ve just purged a Zombie Apepe as part of the Zombie Purge! I\'m now an official holder of the special painting \'The End of the War\', which gives me a special trait for the future Apepe Rebirth.';
		const url = `Participate in the Zombie Purge at ${zombiePurgeLink}`;
		const hashtags = '#RareApepes #ZombiePurge #ApepeRebirth';

		const tweetText = `${text}\n\n${url}\n\n${hashtags}`;
		
		const tweetUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent( tweetText )}`;
	
		window.open( tweetUrl, '_blank' );
	};


	useEffect( ()=>{
		gsap.to( window, {
			duration: 1,
			scrollTo: { y: '#zombie-purge-success', offsetY: 80 },
		});
	}, []);

	return (
		<ZombiePurgeContent>
			<div id="zombie-purge-success"
				className="flex flex-col items-center">
				<h1 className='m-0 p-0  text-5xl text-center uppercase leading-1 mb-4 max-w-md'>purge completed</h1>
				<p className='m-0 p-0 text-center text-[16px]'>Your sacrifice to fight the Zombie Apocalypse has been rewarded!</p>
				<div 
					className="relative "> 	
					<Ribbon ribbonWidth={132}
						ribbonHeight={125}
						ribbonValue={purgedZombiesCount}
						ribbonLabel="MINTED"
						className={`top-0  ${styles['zombie-purge-success-ribbon']}`}
						numberClassName='text-5xl max-[500px]:text-4xl'
						wordClassName='text-lg max-[500px]:text-sm'
					/>
					{/* TODO: update with actual image */}
					<Image className='mt-[30px] mb-[30px] max-[500px]:mt-[45px]'
						src="/images/ZombiePurge/EndOfWar.jpeg"
						width={1024 / 2}
						height={1280 / 2}
					/>
				</div>

				<Link external
					href={RARIBLE_LINKS.APEPE_LOOT}
					className='-f-family-burbank flex items-center hover:color-[#b3fe00]'>
					<Icon className="mr-3 "
						type="rarible" />
					<span className="mt-1">View on Rarible</span>
				</Link>

				<h1 className='m-0 p-0 text-5xl text-center uppercase leading-1 mt-6 mb-6 max-w-sm'>
					'The end of the war'
				</h1>
				<p className='text-sm max-w-xl mb-4'>This painting exists in the Apepe Universe and represents the victory of the genesis Apepes over the Zombies. It is said that the painting is made with a very peculiar substance that was abundant during the war. This peculiar substance could potentially have an impact on the genesis Apepes, given the right conditions...</p>

				<ActionButton onClick={shareOnTwitter}
					className='text-[32px]'
					textContent="tweet this"
				/>

				<p onClick={resetPage}
					className='pt-6 text-sm text-white cursor-pointer'>
						purge more Zombies
				</p>
				
				<p onClick={onClickReplay}
					className='pt-6 text-sm text-white cursor-pointer'>
					replay the purging animation video
				</p>

			</div>
		</ZombiePurgeContent>
	);
}



